/**
 * Decisões PURAS sobre comentários (sem Office.js), verificadas fora do Word
 * por `npm run check:comments`. Quem lê e escreve no documento é `tools.ts`.
 */
/**
 * Página de threads para `list_comments`.
 *
 * O cursor é a posição na lista COMPLETA (abertas + resolvidas), não na lista
 * filtrada. Medido no Word: o fluxo que o prompt ensina — listar as abertas,
 * responder e resolver, pedir a página seguinte — encolhia a lista filtrada
 * entre uma chamada e outra, e o `startIndex` antigo pulava threads (T4 e T5
 * nunca apareciam). Resolver uma thread não a tira da lista completa, então a
 * posição não anda.
 */
export function pageOfThreads(resolved, includeResolved, startIndex, max) {
    const casa = (i) => includeResolved || !resolved[i];
    const matchingCount = resolved.reduce((n, _, i) => n + (casa(i) ? 1 : 0), 0);
    const start = Math.min(Math.max(0, Math.floor(startIndex) || 0), resolved.length);
    const picked = [];
    let i = start;
    for (; i < resolved.length && picked.length < max; i++)
        if (casa(i))
            picked.push(i);
    // Sobra thread que casa depois da última varrida?
    let resta = false;
    for (let j = i; j < resolved.length; j++) {
        if (casa(j)) {
            resta = true;
            break;
        }
    }
    return Object.assign(Object.assign({ picked,
        matchingCount }, (resta ? { nextStartIndex: i } : {})), { window: { startIndex: start, endIndexInclusive: i - 1 } });
}
/** Teto de caracteres por comentário/resposta devolvido ao modelo. */
export const MAX_COMMENT_TEXT_CHARS = 2000;
/**
 * Corta um texto de comentário longo. Sem teto, uma página de 200 threads com
 * respostas longas ocupava dezenas de milhares de tokens de uma vez.
 */
export function clipCommentText(text, max = MAX_COMMENT_TEXT_CHARS) {
    if (text.length <= max)
        return text;
    return `${text.slice(0, max)}… [cortado: ${text.length - max} caracteres a mais]`;
}
